import { render } from "./DeleteContact.vue?vue&type=template&id=57045046&ts=true"
import script from "./DeleteContact.vue?vue&type=script&lang=ts"
export * from "./DeleteContact.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/aleksandrvasilevic/Documents/Dev/WEB/Pets/phone-book/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__